import AppConstant from '../../../../config/app.constants';

class CancelledShipmentController {
    /*@ngInject*/
    constructor(Auth, User, SetupService, ShipmentService, Navigation, Modal, $state, $rootScope) {
        this.Auth = Auth;
        this.User = User;
        this.SetupService = SetupService;
        this.ShipmentService = ShipmentService;
        this.Navigation = Navigation;
        this.Modal = Modal;
        this.$state = $state;
        this.$rootScope = $rootScope;

        this.model = {
            branch: User.getUser().branchId,
            getPendingCancelShp: false,
            getCancelledShp: false,
            pendingCancelShipments: [],
            cancelledShipments: [],
            loading: false,
            pendingCancelShipmentError: null,
            cancelledShipmentError: null
        };

        this.cancelledShpPaginationObj = {
            page: 1,
            total: 0,
            pageLimit: AppConstant.defaultPageLimit,
            maxPages: 10
        };

        this.pendingCancelShpPaginationObj = {
            page: 1,
            total: 0,
            pageLimit: AppConstant.defaultPageLimit,
            maxPages: 10
        };
        this.sortColumn = "trackingId";
        this.reverseSort = true;
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/cancelled-shipments');
    }

    $onInit() {
        this.getPendingCancelShipment();
        this.getCancelledShipments();
    }

    getPendingCancelShipment() {
        this.model.getPendingCancelShp = true;

        this.ShipmentService.getPendingCancelShipments(this.model.branch, (this.pendingCancelShpPaginationObj.page - 1) * this.pendingCancelShpPaginationObj.pageLimit, this.pendingCancelShpPaginationObj.pageLimit)
            .then((data) => {
                this.model.pendingCancelShipments = data.results;
                this.pendingCancelShpPaginationObj.total = data.totalRecords;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.model.pendingCancelShipmentError = err.data.message;
                }
            })
            .finally(() => {
                this.model.getPendingCancelShp = false;
            })
    }

    getCancelledShipments() {
        this.model.getCancelledShp = true;

        this.ShipmentService.getCancelledShipments(this.model.branch, (this.cancelledShpPaginationObj.page - 1) * this.cancelledShpPaginationObj.pageLimit, this.cancelledShpPaginationObj.pageLimit)
            .then((data) => {
                this.model.cancelledShipments = data.results;
                this.cancelledShpPaginationObj.total = data.totalRecords;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.model.cancelledShipmentError = err.data.message;
                }
            })
            .finally(() => {
                this.model.getCancelledShp = false;
            })
    }

    goToItemHistory(trackingId) {
        this.$state.go('branchManagement.items', {
            id: trackingId,
        });
    }

    goToServiceHistory(locationId) {
        return this.Navigation.goToServiceHistory(locationId, null, true, null)
    }

    goToOrderHistory(data) {
        return this.Navigation.goToOrderHistory(data.orderNo, data.vaultDate, true, false, true, false, null);
    }

    orderPackingUndo(shipment) {
        if (this.loading) return;
        this.loading = true;

        this.Modal.undoPackedOrder(shipment, ({ modal, supervisorId, deleteOrder, deletedReason, $scope }) => {
            console.log(supervisorId, deleteOrder, deletedReason);
            this.ShipmentService.orderPackingUndo(this.model.branch, shipment.shipmentId, supervisorId, deletedReason, deleteOrder)
                .then(() => {
                    modal.close();
                    this.loading = false;
                    this.loadData();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        this.loading = false;
                        this.Modal.errorModal('error.' + err.data.message);
                    }
                })
        }, ({ modal }) => {
            if (modal) modal.close();
            this.loading = false;
        })
    }

    sortData(column) {
        this.reverseSort = (this.sortColumn == column) ? !this.reverseSort : false;
        this.sortColumn = column;
    }

    loadData() {
        this.pendingCancelShpPaginationObj.page = 1;
        this.getPendingCancelShipment();
    }

    goToBulkCash() {
        this.$state.go('bulkCashManagement');
    }
}

export default CancelledShipmentController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/cancelled_shipments/cancelled_shipments.controller.js